import gql from 'graphql-tag';









const getProjectsConsumptionQuery = gql`
  query getContractItemConsumptionByResourceType(
    $organisationId: String!
    $resourceType: String!,
    $resourceOwner: String!
    $type: String!,
    $resourceKeyword: String!) {
  getContractItemConsumptionByResourceType(
    organisationId: $organisationId
    resourceType: $resourceType,
    resourceOwner: $resourceOwner
    type: $type,
    resourceKeyword: $resourceKeyword) {
    resourceType
    resourceId
    resourceName
    type
    value
  }
}
`;

export default (() => ({
  query: getProjectsConsumptionQuery,
  module: 'organisations',
  buildVariables: ({
    organisationId,
    resourceType,
    resourceOwner,
    type,
    resourceKeyword
  }) => ({
    organisationId,
    resourceType,
    resourceOwner,
    type,
    resourceKeyword
  })
}));